(function(){
  var terms=null;
  function list(){
    if(!terms){terms={};document.querySelectorAll('#dc-terminals option').forEach(function(o){terms[o.value]=o;});}
    return terms;
  }
  function root(){ return (window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/'; }
  function post(url,body){
    return fetch(root()+url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body),credentials:'same-origin'});
  }
  function sync(box){
    var m=box.querySelector('input[type=radio]:checked'); var v=m?m.value:'';
    box.querySelector('[data-dc-terminal]').hidden=v!=='Paštomatas';
    box.querySelector('[data-dc-home]').hidden=v!=='Į namus';
    return v;
  }
  function attrsFor(v,t){
    return {'Pristatymo būdas':v,'Paštomatas':(v==='Paštomatas'&&list()[t])?t:''};
  }
  document.addEventListener('change',function(e){
    var box=e.target.closest('[data-delivery-choice]'); if(!box) return;
    var v=sync(box); var t=box.querySelector('[data-dc-terminal] input').value.trim();
    box.querySelector('[data-dc-error]').hidden=true;
    post('cart/update.js',{attributes:attrsFor(v,t)}).catch(function(){});
  });
  function validate(box){
    var err=box.querySelector('[data-dc-error]'); var v=sync(box);
    var t=box.querySelector('[data-dc-terminal] input').value.trim();
    var msg=!v?'Pasirinkite pristatymo būdą.':(v==='Paštomatas'&&!list()[t]?'Pasirinkite paštomatą iš sąrašo.':'');
    err.textContent=msg; err.hidden=!msg; return msg?null:{v:v,t:v==='Paštomatas'?t:''};
  }
  var COUNTRY={LT:'Lithuania',LV:'Latvia',EE:'Estonia'};
  function buildUrl(cart,r){
    var q=[];
    function add(k,val){ if(val!==undefined&&val!==null&&val!=='') q.push(encodeURIComponent(k)+'='+encodeURIComponent(val)); }
    add('attributes[Pristatymo būdas]',r.v);
    add('attributes[Paštomatas]',r.t);
    if(r.v==='Paštomatas'){
      var mm=/#(\d+)\)\s*$/.exec(r.t||''); var x=(mm&&window.DC_TERMINALS&&DC_TERMINALS[mm[1]])||[]; var d={id:mm?mm[1]:'',n:x[0],a:x[1],c:x[2],z:x[3],cc:x[4]};
      add('checkout[shipping_address][address1]',d.a);
      add('checkout[shipping_address][address2]','LP Express paštomatas: '+d.n+' (#'+d.id+')');
      add('checkout[shipping_address][city]',d.c);
      add('checkout[shipping_address][zip]',d.z);
      add('checkout[shipping_address][country]',COUNTRY[d.cc]||d.cc);
      add('checkout[shipping_address][country_code]',d.cc);
    }
    if(cart&&cart.note) add('note',cart.note);
    var items=(cart&&cart.items)||[];
    var plain=items.length&&items.every(function(i){
      return !i.properties||Object.keys(i.properties).length===0;
    })&&!(cart.cart_level_discount_applications&&cart.cart_level_discount_applications.length);
    if(plain){
      var map={},order=[];
      items.forEach(function(i){ if(!map[i.variant_id]){map[i.variant_id]=0;order.push(i.variant_id);} map[i.variant_id]+=i.quantity; });
      var path=order.map(function(id){return id+':'+map[id];}).join(',');
      return root()+'cart/'+path+'?'+q.join('&');
    }
    return root()+'checkout?'+q.join('&');
  }
  document.addEventListener('click',function(e){
    var btn=e.target.closest('button[name="checkout"]'); if(!btn) return;
    var form=btn.form; if(!form) return;
    var box=form.querySelector('[data-delivery-choice]'); if(!box) return;
    var cb=document.getElementById('cart-terms-checkbox');
    if(cb&&!cb.checked) return; // let terms check show its own error
    var r=validate(box);
    e.preventDefault(); e.stopImmediatePropagation();
    if(!r){ box.scrollIntoView({behavior:'smooth',block:'center'}); return; }
    var method=form.querySelector('[data-dc-method-value]');
    var terminal=form.querySelector('[data-dc-terminal-value]');
    if(method) method.value=r.v;
    if(terminal) terminal.value=r.t;
    btn.disabled=true; btn.setAttribute('aria-busy','true');
    var attrs=attrsFor(r.v,r.t);
    var tag=r.v==='Paštomatas'?'Pristatymas: LP Express paštomatas – '+r.t:'Pristatymas: į namus (kurjeriu)';
    var noteEl=form.querySelector('[name="note"]');
    var userNote=(noteEl?noteEl.value:'').split('\n').filter(function(l){return l.indexOf('Pristatymas: ')!==0;}).join('\n').trim();
    var note=userNote?userNote+'\n'+tag:tag;
    if(noteEl) noteEl.value=note;
    post('cart/update.js',{attributes:attrs,note:note})
      .then(function(res){ return res.json(); })
      .catch(function(){ return fetch(root()+'cart.js',{credentials:'same-origin'}).then(function(x){return x.json();}); })
      .then(function(cart){ window.location.href=buildUrl(cart,r); })
      .catch(function(){ window.location.href=root()+'checkout'; });
  },true);
})();
